import { Button, POPOVER_MAX_HEIGHT, Spinner as SpinnerFlyui } from "@wayflyer/flyui";
import { styled } from "styled-components";

import { PinnedMetrics } from "./pinned-metrics";

export const FullWidthButton = styled(Button)`
  min-width: unset;
  width: 100%;
`;

export const DataGroupContainer = styled.div`
  padding: 16px 0;

  button p {
    margin: 0;
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const DateRangeComboContainer = styled.div<{ useSimplePanel: boolean; width?: string }>`
  ${({ useSimplePanel = false }) => {
    return !useSimplePanel
      ? ""
      : `
        background-color: transparent;
      `;
  }}
  width: ${({ width }) => {
    return width ?? "200px";
  }};
  @media (max-width: 768px) {
    margin: 20px;
  }
`;

export const DateRangeSelectorContainer = styled.div`
  select {
    border: 1px solid var(--palette-border-neutral-subtle);
    border-radius: var(--defaults-borderRadius);
    height: 40px;
    margin-left: 8px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: var(--palette-bg-neutral-base);
    color: var(--palette-content-neutral-strong);
    padding: 0px 11px;
    text-align: center;
    line-height: 38px;
    cursor: pointer;
    gap: 4px;
  }

  select:hover {
    border: 1px solid var(--palette-content-neutral-subtle);
  }
`;

export const Spinner = () => (
  <LoaderContainer data-testid="perf-loading-spinnor">
    <SpinnerFlyui size={32} />
  </LoaderContainer>
);

export const ChartContainer = styled.div`
  width: 100%;
  flex: 1 1 0%;
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: row;
`;

export const LtvCacFiltersContainer = styled.div`
  width: 100%;
  display: flex;
  -webkit-box-pack: center;
  justify-content: space-evenly;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: row;
  padding-top: 16px;
  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

export const LtvCacFilterContainer = styled.div`
  width: 100%;
  margin-right: 20px;

  &:first-child {
    margin-left: 20px;
  }

  @media (max-width: 640px) {
    margin-left: 30px !important;
    margin-right: 30px;
  }
`;

export const ProfitabilityChartsContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (min-width: 768px) {
    align-items: flex-start;
  }
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const ChartTopRow = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  padding: 0 20px;
`;

export const getReferenceColor = ({ theme, success }) => {
  return success ? theme.palette.content.status.positiveStrong : theme.palette.content.status.critical;
};

export const TooltipContainer = styled.div`
  margin-left: var(--sizes-spacing-1);
`;

export const PinnedMetricsTabContainer = styled(PinnedMetrics)`
  min-height: ${POPOVER_MAX_HEIGHT + 20}px;
`;
